import { useState } from 'react';
import { useInterval } from './useInterval';

const UPDATE_INTERVAL = 1_000;

export const useCountdown = (time: number) => {
	const [countdown, setCountdown] = useState(time);

	useInterval(() => {
		setCountdown(prev => prev - 1);
	}, UPDATE_INTERVAL);

	return Math.max(countdown, 0);
};
